(function() {
    'use strict';

    angular
        .module('TR')
        .service('urlStoreService', urlStoreService);

    function urlStoreService($location, $route) {

        const service = {
            pushURL,
            getPreviousURL,
            getURLHistory,
            cameFromWrongPath,
            isTripIdChanged,
            isPreviousUrlHotelDetails,
            isPreviousUrlHotelOptions,
            isPreviousUrlHotelBook
        };

        function pushURL() {
            let storage = sessionStorage.getItem('URLstorage');
            let currURL = $location.$$path;
            let currPage = ($route.current && $route.current.$$route && $route.current.$$route.analyticsTag) ? $route.current.$$route.analyticsTag : currURL === '/' ? 'Home' : '';
            if (storage === null) {
                storage = {
                    urls: [null],
                    previous: null,
                    pages: [null],
                    previousPage: null
                };
            } else {
                storage = JSON.parse(storage);
            }
            // ignore (do not push url in the storage) if user reload the page
            if (storage.urls[storage.urls.length - 1] !== currURL) {
                storage.urls.push(currURL);
                // find previous url in storage
                storage.previous = storage.urls.slice(-2)[0];

                if (storage.urls.length > 4) {
                    // delete url before previous if it equal to current url,
                    // we need this to check if user click back then forward after that back button
                    // it is no make sense to store this in the history
                    if (storage.urls[storage.urls.length - 3] === currURL) {
                        storage.urls.splice(-3, 1);
                    } else {
                        // clear not needed url history to save storage memory
                        storage.urls.shift();
                    }
                }
            }
            if (storage.pages && storage.pages.length && storage.pages[storage.pages.length - 1] !== currPage) {
                storage.pages.push(currPage);
                storage.previousPage = storage.pages.slice(-2)[0];
                if (storage.pages.length > 4) {
                    if (storage.pages[storage.urls.length - 3] === currPage) {
                        storage.pages.splice(-3, 1);
                    } else {
                        storage.pages.shift();
                    }
                }
            }
            sessionStorage.setItem('URLstorage', JSON.stringify(storage));
        }

        function getPreviousURL() {
            let storage = sessionStorage.getItem('URLstorage');
            return storage ? JSON.parse(storage).previous : null;
        }

        function getURLHistory() {
            let storage = sessionStorage.getItem('URLstorage');
            return storage ? JSON.parse(storage).urls : null;
        }

        function isTripIdChanged() {
            const previousURL = getPreviousURL();
            let changed = false;
            if (previousURL !== null) {
                let splitedCurrentPath = $location.$$path.split('/');
                const currentTripId = splitedCurrentPath.pop();
                let splitedPreviousPath = previousURL.split('/');
                const previousTripId = splitedPreviousPath.pop();
                if (JSON.stringify(splitedCurrentPath) === JSON.stringify(splitedPreviousPath) && currentTripId !== previousTripId) {
                    changed = true;
                }
            }
            return changed;
        }

        function isPreviousUrlHotelDetails(tripId) {
            const r = new RegExp(`/?holidays/${tripId}/[^/]+`, 'gi');
            return r.test(getPreviousURL());
        }

        function isPreviousUrlHotelOptions(tripId) {
            const r = new RegExp(`/?holidays/options/${tripId}/?`, 'gi');
            return r.test(getPreviousURL());
        }

        function isPreviousUrlHotelBook(tripId) {
            const r = new RegExp(`/?holidays/book/${tripId}/?`, 'gi');
            return r.test(getPreviousURL());
        }

        function cameFromWrongPath(applicablePathRegEx) {
            const previousURL = getPreviousURL();
            return previousURL !== null ? previousURL.match(applicablePathRegEx) === null : true;
        }

        return service;
    }
})();
